import { combineReducers } from "redux";
import taxonomyReducer from "../reducers/TaxonomyReducer";

export const mainReducer = combineReducers({
  taxonomy: taxonomyReducer,
});
